export default __webpack_public_path__ + "static/media/ThirdParty.d50f9cb5.png";